import { ReactNode } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Control, FieldValues } from 'react-hook-form';
import { CostFieldConfig } from '../../config/costStructureFields';
import { CostFieldInput } from './CostFieldInput';

type CostFieldSectionProps<T extends FieldValues> = {
  title: string;
  fields: CostFieldConfig[];
  control: Control<T>;
  children?: ReactNode;
  footer?: ReactNode;
  isFixedOverride?: boolean;
};

const groupFieldRows = (fields: CostFieldConfig[]): CostFieldConfig[][] =>
  fields.reduce<CostFieldConfig[][]>((rows, field) => {
    if (rows.length === 0 || field.startNewRow) {
      rows.push([field]);
    } else {
      rows[rows.length - 1].push(field);
    }
    return rows;
  }, []);

export const CostFieldSection = <T extends FieldValues>({
  title,
  fields,
  control,
  children,
  footer,
  isFixedOverride = false,
}: CostFieldSectionProps<T>) => {
  const classes = useStyles();
  const fieldRows = groupFieldRows(fields);

  return (
    <Box mt={1}>
      <Box display="flex" mb={2}>
        <Typography
          variant="body2"
          gutterBottom
          className={classes.sectionTitle}
        >
          {title}
        </Typography>
      </Box>
      {children}
      {fieldRows.map((row, index) => (
        <Box
          key={row[0].source}
          display="flex"
          flexWrap="wrap"
          mt={index === 0 ? 0 : 2}
        >
          {row.map(field => (
            <CostFieldInput
              key={field.source}
              field={field}
              control={control}
              className={classes.inputNumberCost}
              required={isFixedOverride && !!field.requiredWhenFixed}
            />
          ))}
        </Box>
      ))}
      {footer}
    </Box>
  );
};

const useStyles = makeStyles({
  inputNumberCost: {
    margin: '0px 15px 0px 0px',
    minWidth: '240px',
  },
  sectionTitle: {
    fontWeight: 'bold',
  },
});
